module.exports = __webpack_public_path__ + "media/components/assets/img/bg/cloude-airplane-8f14b0da6bc945538fea00b77c8cc74e.svg";